<div class="mb-container {{ class }}" [class.py-12]="py" [class.lg:py-24]="py">
    <ng-content></ng-content>
</div>